
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.79 19.904c-.057-1.41-1.22-2.55-2.648-2.597a2.735 2.735 0 00-1.774.569l-.364.28-.364-.28a2.73 2.73 0 00-1.774-.569c-1.428.046-2.592 1.187-2.648 2.597a2.701 2.701 0 001.095 2.277l.237.176v1.596c0 .437.084.856.237 1.241.61-.201 1.7-.465 3.217-.465 1.516 0 2.607.264 3.217.465.153-.385.237-.803.237-1.241v-1.596l.237-.176a2.702 2.702 0 001.095-2.277zm-7.499-.476h1.334V20.6h-1.334v-1.172zm2.046 3.807h-1.334v-1.171h1.334v1.171zm2.668 0h-1.334v-1.171h1.334v1.171zm.712-2.635h-1.334v-1.172h1.334V20.6zM30 25.899c-1.158 0-2.028.171-2.574.325A3.465 3.465 0 0030 27.363c1.021 0 1.94-.44 2.574-1.14-.546-.153-1.416-.324-2.574-.324z","fill":"#fff"}}),_c('path',{attrs:{"d":"M37.967 21.892l-.489-5.163a7.37 7.37 0 00-2.42-4.795A7.548 7.548 0 0030 10a7.548 7.548 0 00-5.058 1.934 7.37 7.37 0 00-2.42 4.795l-.488 5.163a7.275 7.275 0 00.372 3.102 7.37 7.37 0 001.553 2.584A7.532 7.532 0 0029.511 30h.977a7.532 7.532 0 005.553-2.422 7.37 7.37 0 001.553-2.584c.347-.996.473-2.04.373-3.102zm-3.326 1.036v1.025c0 2.527-2.082 4.583-4.641 4.583s-4.64-2.056-4.64-4.583v-1.025a3.864 3.864 0 01-1.332-3.07c.081-2.02 1.748-3.655 3.795-3.722a3.981 3.981 0 012.177.567 3.983 3.983 0 012.177-.567c2.047.067 3.714 1.701 3.794 3.722a3.865 3.865 0 01-1.33 3.07z","fill":"#fff"}})])
          )
        }
      }
    